// © Microsoft Corporation. All rights reserved.

import React, { useEffect, useRef, useState } from 'react';
import { Image, ImageFit, Label } from '@fluentui/react';
import { LocalVideoStream, VideoStreamRenderer, VideoStreamRendererView } from '@azure/communication-calling';
import { videoHint, mediaContainerNoLabel, localVideoContainerStyle, LabelContainer } from './styles/StreamMedia.styles';
import { Constants } from '../core/constants';
import staticMediaSVG from '../assets/staticmedia.svg';
import { IsSecondaryStream } from '../Utils/Utils';

export interface LocalStreamMediaProps {
    label: string;
    stream: LocalVideoStream;
}

export default (props: LocalStreamMediaProps): JSX.Element => {
    const rendererViewRef = useRef<VideoStreamRendererView>();

    const [activeStreamBeingRendered, setActiveStreamBeingRendered] = useState(false);

    const imageProps = {
        src: staticMediaSVG.toString(),
        imageFit: ImageFit.contain,
        styles: {
            root: {
                width: '100%',
                height: '90%',
                display: activeStreamBeingRendered ? 'none' : 'block'
            }
        }
    };

    const { stream, label } = props;

    useEffect(() => {
        (async (): Promise<void> => {
            if (stream) {
                try {

                    const renderer: VideoStreamRenderer = new VideoStreamRenderer(stream);
                    rendererViewRef.current = await renderer.createView({ scalingMode: 'Fit', isMirrored: true });

                    var videoList = rendererViewRef.current.target.getElementsByTagName("video");
                    for (let i = 0; i < videoList.length; i++) {
                        videoList[i].attributes.setNamedItem(document.createAttribute("disablePictureInPicture"));
                    }

                    const container = document.getElementById(Constants.LOCAL_VIDEO_PREVIEW_ID);

                    if (container && container.childElementCount === 0) {
                        container.appendChild(rendererViewRef.current.target);
                        setActiveStreamBeingRendered(true);
                    }
                    else {
                        if (rendererViewRef) {
                            rendererViewRef.current?.dispose();
                            setActiveStreamBeingRendered(false);
                        }
                    }
                }
                catch (err) {

                    console.log(err)
                }
            }
        })();

        return (): void => {
            try {
                if (rendererViewRef && rendererViewRef.current) {
                    rendererViewRef.current?.dispose();
                    rendererViewRef.current = undefined;
                    setActiveStreamBeingRendered(false);
                }
                else {
                    rendererViewRef.current = undefined;
                    setActiveStreamBeingRendered(false);
                }
            }
            catch (err) {
                console.log(err);
                rendererViewRef.current = undefined;
                setActiveStreamBeingRendered(false);
            }
        };
    }, [stream]);

    return (
        <div className={mediaContainerNoLabel}>
            <div
                style={{ display: activeStreamBeingRendered ? 'block' : 'none' }}
                className={localVideoContainerStyle}
                id={Constants.LOCAL_VIDEO_PREVIEW_ID}
            />
            <Image{...imageProps} />
            {!IsSecondaryStream() &&
                <div className={LabelContainer}>
                    <Label className={videoHint}>{label}</Label>
                </div>
            }
        </div>
    );
};